export default "__VITE_ASSET__c82d548f__"